import Cookies from "js-cookie"
import React, { useContext, useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"

import MyContext from "../context/context"

// MUI
import { AutoAwesome, CardGiftcard, CoPresent, Face, Menu, PowerSettingsNew, RateReview, Receipt } from "@mui/icons-material"
import { AppBar, Box, Button, CircularProgress, Dialog, DialogContent, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, SwipeableDrawer, Toolbar, Typography } from "@mui/material"

export default function SidebarUser() {
	const api = useContext(MyContext)
	const [open, setOpen] = useState("")
	const [action, setAction] = useState("")
	const auth = Cookies.get("authuser")
	useEffect(() => {
		if (auth === undefined) {
			navi("/login-student")
		}
	}, [auth])

	useEffect(() => {
		window.location.replace("https://app.spywarecomputers.com/student")
	}, [])

	const navi = useNavigate()
	const location = useLocation()
	const link = [
		{ name: "Spyware", link: "/student/home", icon: <AutoAwesome /> },
		{ name: "Payment", link: "/student/payment", icon: <Receipt /> },
		{ name: "Attendance", link: "/student/attendance", icon: <CoPresent /> },
		{ name: "Rewards", link: "/student/rewards", icon: <CardGiftcard /> },
		{ name: "Profile", link: "/student/profile", icon: <Face /> },
	]

	const [value, setValue] = React.useState(0)
	useEffect(() => {
		const storedValue = localStorage.getItem("activeButtonIndex")
		if (storedValue !== null) {
			setValue(parseInt(storedValue))
		}
	}, [])
	const change_btn_color = (event, newValue) => {
		setValue(newValue)
		localStorage.setItem("activeButtonIndex", newValue)
	}

	const logout = () => {
		setAction("loggingout")
		var formData = new FormData()
		formData.append("logout", "")
		fetch(api.api.student, {
			method: "post",
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				setAction("")
				if (data.status === true) {
					navi("/login-student", { replace: true })
				}
			})
	}

	const [drawerOpen, setDrawerOpen] = useState(false)

	return (
		<Box component="nav">
			<Dialog
				open={open === "logout"}
				fullWidth
				maxWidth="xs"
				onClose={() => setOpen("")}
				PaperProps={{
					sx: {
						borderRadius: 3,
						boxShadow: "none",
						border: "1px solid",
						borderColor: "rgba(0, 0, 0, 0.07)",
					},
				}}
			>
				<DialogContent sx={{ p: 4 }}>
					<Box textAlign="center">
						<Box
							sx={{
								width: 64,
								height: 64,
								borderRadius: "50%",
								backgroundColor: "error.light",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								margin: "0 auto 16px",
								opacity: 0.9,
							}}
						>
							<PowerSettingsNew sx={{ fontSize: 32, color: "white" }} />
						</Box>

						<Typography fontWeight={700} fontSize={24} color="text.primary" mb={1}>
							Logout Confirmation
						</Typography>

						<Typography variant="body2" color="text.secondary" mb={3}>
							Are you sure you want to logout? You'll need to sign in again to access your account.
						</Typography>

						<Stack direction="row" spacing={2} justifyContent="center">
							<Button
								variant="outlined"
								color="inherit"
								onClick={() => setOpen("")}
								disabled={action === "loggingout"}
								sx={{
									borderRadius: 2,
									px: 3,
									textTransform: "none",
									fontWeight: 600,
								}}
							>
								Cancel
							</Button>
							<Button
								variant="contained"
								color="error"
								onClick={() => logout()}
								disabled={action === "loggingout"}
								sx={{
									borderRadius: 2,
									px: 3,
									textTransform: "none",
									fontWeight: 600,
								}}
							>
								{action === "loggingout" ? <CircularProgress color="inherit" size={24} /> : "Logout"}
							</Button>
						</Stack>
					</Box>
				</DialogContent>
			</Dialog>
			<AppBar
				position="fixed"
				color="primary"
				sx={{
					boxShadow: "none",
					borderBottom: "1px solid rgba(0, 0, 0, 0.07)",
				}}
			>
				<Toolbar sx={{ minHeight: { xs: 56, sm: 56 } }}>
					<Typography
						color="white"
						fontSize={{ xs: 20, sm: 24 }}
						className="orbitron"
						fontWeight={700}
						sx={{
							letterSpacing: 1.5,
							textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
							color: "#ffffff !important",
							flexGrow: 1,
						}}
					>
						#SPYWARE
					</Typography>

					{/* Review Button */}
					<IconButton
						color="inherit"
						onClick={() => {
							if (location.pathname === "/student/home") {
								window.dispatchEvent(new Event("openReviewDialog"))
							} else {
								navi("/student/home", { state: { openReview: true } })
							}
						}}
						sx={{
							backgroundColor: "rgba(255,255,255,0.15)",
							"&:hover": {
								backgroundColor: "rgba(255,255,255,0.25)",
							},
							mr: 1,
						}}
					>
						<RateReview />
					</IconButton>

					{/* Desktop Logout Button */}
					<IconButton
						color="inherit"
						onClick={() => setOpen("logout")}
						sx={{
							display: { xs: "none", sm: "flex" },
							backgroundColor: "rgba(255,255,255,0.15)",
							"&:hover": {
								backgroundColor: "rgba(255,255,255,0.25)",
							},
						}}
					>
						<PowerSettingsNew />
					</IconButton>

					{/* Mobile Menu Button */}
					<IconButton
						color="inherit"
						onClick={() => setDrawerOpen(true)}
						sx={{
							display: { xs: "flex", sm: "none" },
							color: "#ffffff",
						}}
					>
						<Menu />
					</IconButton>
				</Toolbar>
			</AppBar>

			{/* Mobile Bottom Drawer */}
			<SwipeableDrawer
				anchor="bottom"
				open={drawerOpen}
				onClose={() => setDrawerOpen(false)}
				onOpen={() => setDrawerOpen(true)}
				PaperProps={{
					sx: {
						borderTopLeftRadius: 16,
						borderTopRightRadius: 16,
						boxShadow: "none",
						border: "1px solid rgba(0, 0, 0, 0.07)",
						maxHeight: "70vh",
					},
				}}
				sx={{ display: { xs: "block", sm: "none" } }}
			>
				<Box sx={{ p: 2 }}>
					{/* Drawer Handle */}
					<Box
						sx={{
							width: 40,
							height: 4,
							borderRadius: 2,
							backgroundColor: "rgba(0,0,0,0.2)",
							mx: "auto",
							mb: 2,
						}}
					/>

					{/* Navigation Links */}
					<List sx={{ p: 0 }}>
						{link.map((row, i) => (
							<ListItem key={i} sx={{ p: 0, mb: 0.5 }}>
								<ListItemButton
									onClick={() => {
										navi(row.link)
										setDrawerOpen(false)
									}}
									selected={location.pathname === row.link}
									sx={{
										borderRadius: 2,
										py: 1.5,
										"&.Mui-selected": {
											backgroundColor: "primary.main",
											"& .MuiListItemIcon-root": {
												color: "#ffffff",
											},
											"& .MuiListItemText-primary": {
												color: "#ffffff",
												fontWeight: 600,
											},
										},
									}}
								>
									<ListItemIcon sx={{ minWidth: 45 }}>{row.icon}</ListItemIcon>
									<ListItemText
										primary={row.name}
										primaryTypographyProps={{
											fontWeight: 500,
											fontSize: "0.95rem",
										}}
									/>
								</ListItemButton>
							</ListItem>
						))}
					</List>

					{/* Logout Button */}
					<Box sx={{ mt: 2, pt: 2, borderTop: "1px solid", borderColor: "rgba(0, 0, 0, 0.07)" }}>
						<Button
							fullWidth
							variant="outlined"
							color="error"
							startIcon={<PowerSettingsNew />}
							onClick={() => {
								setDrawerOpen(false)
								setOpen("logout")
							}}
							sx={{
								borderRadius: 2,
								py: 1.5,
								textTransform: "none",
								fontWeight: 600,
							}}
						>
							Logout
						</Button>
					</Box>
				</Box>
			</SwipeableDrawer>

			<Drawer
				variant="permanent"
				sx={{
					display: { xs: "none", sm: "block" },
				}}
				PaperProps={{
					style: {
						width: "280px",
						background: "#ffffff",
						borderRight: "1px solid rgba(0, 0, 0, 0.07)",
						boxShadow: "none",
					},
				}}
			>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="center"
					height={56}
					sx={{
						backgroundColor: "primary.main",
						boxShadow: "none",
						borderBottom: "1px solid rgba(0, 0, 0, 0.07)",
					}}
				>
					<Typography
						textAlign="center"
						fontSize={22}
						className="orbitron"
						fontWeight={700}
						sx={{
							letterSpacing: 1.5,
							textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
							color: "#ffffff !important",
						}}
					>
						#SPYWARE
					</Typography>
				</Stack>
				<List sx={{ flexGrow: 1, mt: 1, px: 1.5 }}>
					{link.map((row, i) => (
						<ListItem key={i} sx={{ mb: 0.25 }}>
							<ListItemButton
								onClick={() => navi(row.link)}
								selected={location.pathname === row.link}
								sx={{
									borderRadius: 2,
									py: 1,
									transition: "all 0.3s ease",
									"&:hover": {
										backgroundColor: "rgba(14, 58, 67, 0.08)",
										transform: "translateX(4px)",
									},
									"&.Mui-selected": {
										backgroundColor: "primary.main",
										boxShadow: "0 4px 12px rgba(14, 58, 67, 0.3)",
										"&:hover": {
											backgroundColor: "primary.dark",
											transform: "translateX(4px)",
										},
										"& .MuiListItemIcon-root": {
											color: "#ffffff !important",
										},
										"& .MuiListItemText-primary": {
											color: "#ffffff !important",
											fontWeight: 600,
										},
										"& .MuiTypography-root": {
											color: "#ffffff !important",
										},
									},
								}}
							>
								<ListItemIcon sx={{ minWidth: 45 }}>{row.icon}</ListItemIcon>
								<ListItemText
									primary={row.name}
									primaryTypographyProps={{
										fontWeight: 500,
										fontSize: "0.95rem",
									}}
								/>
							</ListItemButton>
						</ListItem>
					))}
				</List>

				<Box sx={{ borderTop: "1px solid", borderColor: "divider", p: 2.5, backgroundColor: "rgba(14, 58, 67, 0.03)" }}>
					<Typography variant="caption" color="text.secondary" display="block" mb={0.5} fontWeight={500}>
						Version 1.0.0
					</Typography>
					<Typography variant="caption" color="text.secondary" display="block" sx={{ fontSize: "0.7rem" }}>
						© 2026 Spyware. All rights reserved.
					</Typography>
				</Box>
			</Drawer>
			<Box
				component="main"
				sx={{
					marginLeft: { xs: 0, sm: "280px" },
					marginTop: "56px",
					minHeight: "calc(100vh - 56px)",
					pt: 1,
					pb: { xs: 1, sm: 2 },
					backgroundColor: "#fafbfc",
				}}
			>
				<Outlet />
			</Box>
		</Box>
	)
}
